// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".users-list[data-v-5553a597]{display:inline-block}.scale-selector[data-v-5553a597]{height:60px}\n", ""]);
// Exports
module.exports = exports;
